"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const destinations = [{
  title: "Thailand",
  description: "World-class courses, warm hospitality and incredible value.",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/Thailand-1.png",
  link: "/course-finder/?tl_country=Thailand"
}, {
  title: "Japan",
  description: "Impeccable courses, unique culture and unforgettable trips.",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/Nippon.png",
  link: "/course-finder/?tl_country=Japan"
}, {
  title: "Vietnam",
  description: "Stunning coastline, emerging golf and vibrant experiences.",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/Vietnam.png",
  link: "/course-finder/?tl_country=Vietnam"
}, {
  title: "Singapore",
  description: "World-class courses, exceptional access and close-to-home escapes.",
  imageSrc: "https://ideal-jay.10web.cloud/wp-content/uploads/2026/07/Singapore-1.png",
  link: "/course-finder/?tl_country=Singapore"
}];
export default function HomeDestinations() {
  return <section id="home-destinations" data-home-section="destinations" aria-label="Golf destinations and travel guides" className="w-full ![padding:80px_48px_80px_48px] dark !bg-[rgba(247,244,236,1)] ![margin:-20px_0px_-20px_0px] !h-[850px]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="mx-auto w-full max-w-[1480px]">
        {/* Section heading */}
        <div className="mx-auto mb-12 max-w-[850px] text-center md:mb-14 lg:mb-16">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#9A793A]"><span className="!text-xs">Destinations &amp; Golf Guides</span></p>

          <h2 className={["mt-4", "text-[40px] font-medium", "leading-[1.06]", "tracking-[-0.03em]", "text-[#073F31]", "md:text-[50px]", "lg:text-[56px]"].join(" ")} style={{
          fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
        }}>
            Extraordinary golf. More to discover.
          </h2>

          <p className="mx-auto mt-4 max-w-[760px] text-[15px] leading-[1.7] text-[#65746D] md:text-[16px]">
            From world-class courses to vibrant cities and coastal escapes.
            Explore top golf destinations and travel guides across Asia.
          </p>
        </div>

        {/* Destination cards */}
        <div className="grid grid-cols-1 gap-5 ![margin:-15px_0px_-15px_0px] sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
          {destinations.map(destination => <Link key={destination.title} to={destination.link} aria-label={`Explore golf guides for ${destination.title}`} className={["group relative block", "h-[420px]", "overflow-hidden rounded-[16px]", "border border-[#DED3BF]", "bg-[#073F31]", "shadow-[0_10px_28px_rgba(7,63,49,0.10)]", "transition-all duration-300", "hover:-translate-y-[4px]", "hover:shadow-[0_18px_38px_rgba(7,63,49,0.17)]", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-[#BFFF00]", "focus-visible:ring-offset-4", "focus-visible:ring-offset-[#FFFDF7]", "md:h-[440px]", "xl:h-[460px]"].join(" ")}>
              <img src={destination.imageSrc} alt={`${destination.title} travel and golf destination`} loading="lazy" decoding="async" className={["absolute inset-0 h-full w-full", "object-cover", "transition-transform duration-700", "group-hover:scale-[1.045]"].join(" ")} />

              {/* Bottom readability gradient */}
              <div aria-hidden="true" className={["pointer-events-none absolute inset-0", "bg-[linear-gradient(180deg,rgba(7,63,49,0.01)_18%,rgba(7,63,49,0.08)_42%,rgba(7,63,49,0.48)_70%,rgba(3,39,31,0.96)_100%)]"].join(" ")} />

              <div className="absolute inset-x-0 bottom-0 z-10 px-6 pb-6 pt-24">
                <h3 className="text-[29px] font-medium leading-[1.08] tracking-[-0.025em] text-[#FFFDF7] drop-shadow-[0_2px_9px_rgba(0,0,0,0.30)]" style={{
              fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
            }}>
                  {destination.title}
                </h3>

                <p className="mt-2.5 max-w-[260px] text-[13px] font-medium leading-[1.55] text-[#FFFDF7]/86">
                  {destination.description}
                </p>

                <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.07em] text-[#BFFF00] transition-all duration-300 group-hover:gap-3">
                  Explore Guides

                  <ArrowRight className="size-4" strokeWidth={1.8} aria-hidden="true" />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}